/** Trim whitespace and lowercase for consistent email comparison. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
